import { TFunction } from 'hooks/useI18n';
import { IntroDataProps } from './Intro.types';

export const INTRODATA = (
  t: TFunction,
  locale: string | undefined,
  manfreditesCount: number
): IntroDataProps[] => [
  {
    value: manfreditesCount.toLocaleString(locale),
    text: t('mantechcar24.data.people')
  },
  {
    value: '+55.000',
    text: t('mantechcar24.data.current')
  },
  {
    value: '50%',
    text: t('mantechcar24.data.companies')
  },
  {
    value: '+650',
    text: t('mantechcar24.data.time-to-hire')
  }
];
